@if (!hideBackButton()) {
  <sd-4-5-1-button
    class="fond-detail-back"
    variant="tertiary"
    size="lg"
    (click)="back()">

    <sd-4-5-1-icon
      library="system"
      name="chevron-down"></sd-4-5-1-icon>

  </sd-4-5-1-button>
}

<rpt-fond-details-content
  *rptHandleErrors="{ style: 'flex-grow: 1;' }"
  [selectedFund]="selectedFund" />

<div class="fund-detail-footer">
  <a [href]="redirectUrl">
    <sd-4-5-1-button
      variant="secondary"
      size="sm">

      {{ 'fondDetails.navigateToFondsportrait' | transloco }}

    </sd-4-5-1-button>
  </a>
</div>
